import axios from "axios";
import React, { useContext, useRef, useState } from "react";
import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useNavigate, useParams } from "react-router-dom";
import globalContext from "../../Contexts/GlobalContext";
import Loader from "../loader/Loader";
import "./CarBox.css";
import MaskedInput from "react-text-mask";
import { FaWheelchair } from "react-icons/fa";
import {
  getValidPlateNumber,
  setValidPlateNumber,
} from "../../utils/plateLetterHandler";
import { SERVERMODE } from "../../constants/serverMode";
import { handleServerMode } from "../../utils/handleServer";
import useRequestHeader from "../../hooks/useRequestHeader";
export default function CarBox({
  plate = "",
  percent,
  logoUrl,
  repairAdd,
  showModuleMode,
  repairAddMessage,
  mode,
  setNewCarPlate,
  forwardRef,
  id,
  isLoading,
  setToastTime,
  setSortCars,
  isDefault,
  setIsDefault,
  hasDefault,
  setHasDefault,
  carsLength,
  isPlateModalOpen,
  setIsPlateModalOpen,

  plateModalLetter,
  setPlateModalLetter,
  checkCarExist,
}) {
  /// root api address section start ///
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  /// root api address section end ///
  const navigate = useNavigate();
  const requestHeader = useRequestHeader();
  const contextData = useContext(globalContext);
  const [cookies, setCookies, removeCookies] = useCookies();
  /// 7 pelak refs start ///
  const plk1 = useRef();
  const plk2 = useRef();
  const plk3 = useRef();
  const plk4 = useRef();
  const plk5 = useRef();
  const plk6 = useRef();
  const plk7 = useRef();
  /// 7 pelak refs end ///
  /// pelaks values state start ///
  const [plk1Value, setPlk1Value] = useState(plate[0] ? plate[0] : "");
  const [plk2Value, setPlk2Value] = useState(plate[1] ? plate[1] : "");
  const [plk3Value, setPlk3Value] = useState(plate[2] ? plate[2] : "");
  const [plk4Value, setPlk4Value] = useState(plate[3] ? plate[3] : "");
  const [plk5Value, setPlk5Value] = useState(plate[4] ? plate[4] : "");
  const [plk6Value, setPlk6Value] = useState(plate[5] ? plate[5] : "");
  const [plk7Value, setPlk7Value] = useState(plate[6] ? plate[6] : "");
  const [alphabetSelect, setAlphabetSelect] = useState("");
  /// pelaks values state end ///

  /// add mode plate letter section strat ///
  const [plateLetterAdd, setPlateLetterAdd] = useState("");

  const [pInp1, setPInp1] = useState("");
  const [pInp2, setPInp2] = useState("");
  const [pInp3, setPInp3] = useState("");
  useEffect(() => {
    setPInp1(
      getValidPlateNumber(plate, "1") ? getValidPlateNumber(plate, "1") : ""
    );
    setPInp2(
      getValidPlateNumber(plate, "2") ? getValidPlateNumber(plate, "2") : ""
    );
    setPInp3(
      getValidPlateNumber(plate, "3") ? getValidPlateNumber(plate, "3") : ""
    );
  }, [plate]);

  useEffect(() => {
    if (mode === "add") {
      setNewCarPlate(
        setValidPlateNumber(pInp1, plateModalLetter, pInp2, pInp3)
      );
    }
  }, [pInp1, pInp2, pInp3, plateModalLetter, plate]);
  useEffect(() => {
    if (contextData?.fireAutoF) {
      const element = document.getElementById("inp_empty");
      element.focus();
    }
  }, [contextData.fireAutoF]);
  /// add mode plate letter section end ///

  const [togglePin, setTogglePin] = useState(false);
  const pinMe = (plate) => {
    let p1 = localStorage.getItem("P1");
    let p2 = localStorage.getItem("P2");
    if (p2) {
      contextData.setIsToastOpen(true);
      contextData.setToastMessage("بیش از دو خودرو نمی‌توانید پین نمایید");
      setToastTime(3000);
    } else {
      if (p1) {
        if (p1 !== plate) {
          localStorage.setItem("P2", p1);
          localStorage.setItem("P1", plate);
          setSortCars(true);
        } else {
          unPinMe(plate);
        }
      } else {
        localStorage.setItem("P1", plate);
        setSortCars(true);
      }
    }
  };
  const unPinMe = (plate) => {
    let p1 = localStorage.getItem("P1");
    let p2 = localStorage.getItem("P2");

    if (p1 === plate) {
      if (p2) {
        localStorage.setItem("P1", p2);
        localStorage.setItem("P2", "");
        setSortCars(true);
      } else {
        localStorage.setItem("P1", "");
        setSortCars(true);
      }
    } else if (p2 === plate) {
      localStorage.setItem("P2", "");
      setSortCars(true);
    }
  };
  const pinImgRef = useRef();
  useEffect(() => {
    if (pinImgRef?.current?.className?.includes("C-pin")) {
      setTogglePin(true);
    }
  }, [pinImgRef]);

  ////----->
  const [logoSrcMain, setLogoSrcMain] = useState("");
  useEffect(() => {
    if (logoUrl === null) {
      setLogoSrcMain("../assets/images/car-details/default logo.svg");
    } else {
      const img = new Image();
      img.src = logoUrl;

      if (img.complete) {
        setLogoSrcMain(logoUrl);
      } else {
        img.onload = () => {
          setLogoSrcMain(logoUrl);
        };
        img.onerror = () => {
          if (logoUrl) {
            setLogoSrcMain("../assets/images/car-details/default logo.svg");
          }
        };
      }
    }
  }, [logoUrl, isDefault, hasDefault]);
  const [isDefault1, setIsDefault1] = useState(isDefault);
  const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

  //// useeffect for focus on plk2 start ////
  useEffect(() => {
    if (plateModalLetter && pInp1) {
      plk2.current.inputElement.focus();
    }
  }, [plateModalLetter]);
  //// useeffect for focus on plk2 end ////

  return (
    <div
      className="relative w-[92.68867924528302vw] h-[29.71698113207547vw] rounded-[1.886792452830189vw] "
      onClick={(e) => {
        if (mode !== "add" && !isLoading) {
          setCookies("plate", plate, { path: "/" });
          for (const item in cookies) {
            if (
              item !== "plate" &&
              item !== "user" &&
              item !== "utt" &&
              item !== "slider"
            ) {
              removeCookies(item);
            }
          }
          if (repairAdd === "R") {
            contextData.setIsRepairAdd(true);
          }
          contextData.setRepairAddMessage(repairAddMessage);

          navigate("/short-terms");
        }
      }}
    >
      {isLoading && (
        <Loader width={12} top={0} zIndex={1000} right={0} bg={"#9E9B96"} />
      )}

      {mode === "add" ? (
        <div
          ref={forwardRef}
          className="w-[92.68867924528302vw] h-[29.71698113207547vw] flex items-center justify-center in"
        >
          <svg
            width="92.68867924528302vw"
            height="29.71698113207547vw"
            viewBox="0 0 393 127"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.1518 0.644539H384.237C388.609 0.644539 392.222 4.22183 392.222 8.6302V118.37C392.222 122.742 388.645 126.355 384.237 126.355H8.1518C3.74342 126.355 0.166138 122.778 0.166138 118.37V8.6302C0.166138 4.22183 3.74342 0.644539 8.1518 0.644539Z"
              fill="#BDBFC1"
              fillOpacity="0.301961"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.1518 0.644539H384.237C388.609 0.644539 392.222 4.22183 392.222 8.6302V118.37C392.222 122.742 388.645 126.355 384.237 126.355H8.1518C3.74342 126.355 0.166138 122.778 0.166138 118.37V8.6302C0.166138 4.22183 3.74342 0.644539 8.1518 0.644539Z"
              stroke="#BDBFC1"
              strokeWidth="0.289074"
              strokeMiterlimit="2.61313"
            />
            <path
              d="M18.6307 16.6159H242.121C242.807 16.6159 243.422 16.9049 243.891 17.3385C244.325 17.8083 244.614 18.4226 244.614 19.1091V60.6996C244.614 61.3861 244.325 62.0004 243.891 62.4702C243.422 62.9399 242.807 63.1929 242.121 63.1929H18.6307C17.9442 63.1929 17.3299 62.9038 16.8601 62.4702C16.4265 62.0004 16.1375 61.3861 16.1375 60.6996V19.1091C16.1375 18.4226 16.4265 17.8083 16.8601 17.3385C17.3299 16.8688 17.9442 16.6159 18.6307 16.6159ZM36.5172 17.5915V62.1811H190.449V17.5915H36.5172ZM35.5415 62.1811V17.5915H18.6669C18.2694 17.5915 17.8719 17.7722 17.619 18.0251C17.3299 18.278 17.1854 18.6755 17.1854 19.073V60.6635C17.1854 61.0609 17.366 61.4584 17.619 61.7114C17.908 62.0004 18.2694 62.145 18.6669 62.145H35.5415V62.1811ZM191.461 17.5915V62.1811H242.157C242.554 62.1811 242.952 62.0004 243.205 61.7475C243.494 61.4584 243.638 61.0971 243.638 60.6996V19.1091C243.638 18.7116 243.458 18.3142 243.205 18.0612C242.916 17.7722 242.554 17.6276 242.157 17.6276H191.461V17.5915Z"
              fill="#BDBFC1"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.0643 50.0761V44.6199H19.6786V50.0761H19.0643ZM22.6055 50.0761V44.6199H24.6651C25.0987 44.6199 25.3878 44.6921 25.6046 44.7644C25.8214 44.8728 26.0021 45.0174 26.1105 45.2703C26.255 45.5232 26.2912 45.8123 26.2912 46.1014C26.2912 46.4989 26.1828 46.8241 25.966 47.077C25.7492 47.3299 25.424 47.5106 24.9903 47.5829C25.1349 47.6913 25.2794 47.7635 25.3517 47.872C25.5324 48.0526 25.713 48.3056 25.8576 48.5946L26.6525 50.0761H25.8576L25.2433 48.9198C25.0626 48.5946 24.9181 48.3417 24.8097 48.161C24.7013 47.9804 24.5929 47.872 24.4845 47.7997C24.3761 47.7274 24.3038 47.6913 24.1954 47.6551C24.1231 47.619 24.0147 47.619 23.834 47.619H23.1114V50.04H22.4971L22.6055 50.0761ZM23.2198 47.0047H24.5567C24.8458 47.0047 25.0626 46.9686 25.2071 46.8963C25.3517 46.8241 25.4962 46.7157 25.5685 46.5711C25.6408 46.4266 25.6769 46.2459 25.6769 46.0652C25.6769 45.8123 25.6046 45.5955 25.424 45.4148C25.2794 45.2342 25.0265 45.1619 24.6651 45.1619H23.1836V46.9686L23.2198 47.0047ZM29.8685 58.5677V53.1114H30.5189L32.976 57.4114V53.1114H33.5903V58.5677H32.9399L30.4827 54.2677V58.5677H29.8685ZM24.9903 58.5677L26.7971 53.1114H27.4836L29.3987 58.5677H28.676L28.134 56.9055H26.1466L25.6408 58.5677H24.9903ZM26.3273 56.3274H27.9172L27.4113 54.8097C27.2668 54.34 27.1584 53.9786 27.0861 53.6896C27.0139 54.0509 26.9416 54.3761 26.8332 54.7375L26.3273 56.3274ZM20.7626 58.5677V53.1114H22.8223C23.2559 53.1114 23.545 53.1475 23.7979 53.256C24.0147 53.3644 24.1954 53.545 24.3038 53.7618C24.4483 54.0148 24.4845 54.2677 24.4845 54.5929C24.4845 54.9904 24.3761 55.3156 24.1593 55.5685C23.9424 55.8215 23.6172 56.0022 23.1836 56.0744C23.3282 56.1467 23.4727 56.2551 23.545 56.3274C23.7256 56.508 23.9063 56.761 24.0509 57.05L24.8458 58.5315H24.0509L23.4366 57.4114C23.2559 57.0862 23.1114 56.8332 23.003 56.6526C22.8946 56.4719 22.7862 56.3635 22.6778 56.2912C22.5694 56.219 22.4971 56.1828 22.3887 56.1467C22.3164 56.1467 22.208 56.1106 22.0273 56.1106H21.3047V58.5315H20.6904L20.7626 58.5677ZM21.3769 55.5324H22.7139C23.003 55.5324 23.2198 55.4963 23.3643 55.424C23.545 55.3517 23.6534 55.2433 23.7256 55.0988C23.7979 54.9543 23.834 54.7736 23.834 54.629C23.834 54.3761 23.7618 54.1593 23.5811 53.9786C23.4366 53.798 23.1836 53.7257 22.8223 53.7257H21.3408V55.5324H21.3769ZM19.0282 58.5677V53.1114H19.6425V58.5677H19.0282ZM27.3752 50.04V49.2812H28.0256V50.04H27.3752ZM20.8349 50.04V49.2812H21.4853V50.04H20.8349Z"
              fill="#BDBFC1"
            />
          </svg>
        </div>
      ) : (
        <div
          ref={forwardRef}
          className="w-[92.68867924528302vw] h-[29.71698113207547vw] in"
        >
          <svg
            width="92.68867924528302vw"
            height="29.71698113207547vw"
            viewBox="0 0 393 127"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.11457 0.646118H384.231C388.614 0.646118 392.23 4.22574 392.23 8.60895V118.372C392.23 122.755 388.614 126.335 384.231 126.335H8.11457C3.73136 126.335 0.151733 122.755 0.151733 118.372V8.60895C0.151733 4.22574 3.73136 0.646118 8.11457 0.646118Z"
              fill="#001D26"
              fillOpacity="0.701961"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.11457 0.646118H384.231C388.614 0.646118 392.23 4.22574 392.23 8.60895V118.372C392.23 122.755 388.614 126.335 384.231 126.335H8.11457C3.73136 126.335 0.151733 122.755 0.151733 118.372V8.60895C0.151733 4.22574 3.73136 0.646118 8.11457 0.646118Z"
              stroke="#00FFF2"
              strokeWidth="0.292214"
              strokeMiterlimit="2.61313"
            />
            <path
              d="M18.5977 16.6083H242.068C242.762 16.6083 243.383 16.9005 243.822 17.3388C244.297 17.8137 244.552 18.3981 244.552 19.0921V60.6961C244.552 61.3901 244.26 62.0111 243.822 62.4494C243.383 62.9242 242.762 63.1799 242.068 63.1799H18.5977C17.9037 63.1799 17.2827 62.9242 16.8444 62.4494C16.4061 61.9745 16.1139 61.3901 16.1139 60.6961V19.0921C16.1139 18.3981 16.4061 17.7772 16.8444 17.3388C17.3193 16.9005 17.9037 16.6083 18.5977 16.6083ZM36.4958 17.5945V62.1937H190.42V17.5945H36.4958ZM35.5096 62.1937V17.5945H18.6342C18.2324 17.5945 17.8306 17.7772 17.575 18.0329C17.3193 18.2885 17.1366 18.6903 17.1366 19.0921V60.6961C17.1366 61.1344 17.3193 61.4997 17.575 61.7554C17.8306 62.0111 18.2324 62.1937 18.6342 62.1937H35.5096ZM191.406 17.5945V62.1937H242.068C242.507 62.1937 242.872 62.0111 243.128 61.7554C243.383 61.4997 243.566 61.1344 243.566 60.6961V19.0921C243.566 18.6903 243.383 18.2885 243.128 18.0329C242.835 17.7772 242.47 17.5945 242.068 17.5945H191.406Z"
              fill="#00FFF2"
            />
            <path
              d="M35.4731 62.1572V17.558H18.5977C18.1959 17.558 17.7941 17.7406 17.5384 17.9963C17.2827 18.252 17.1001 18.6538 17.1001 19.0556V60.6596C17.1001 61.0979 17.2827 61.4632 17.5384 61.7189C17.7941 61.9746 18.1959 62.1572 18.5977 62.1572H35.4731Z"
              fill="#00FFF2"
              fillOpacity="0.2"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.036 50.0668V44.6243H19.657V50.0668H19.036ZM22.5791 50.0668V44.6243H24.6611C25.0995 44.6243 25.3917 44.6609 25.6108 44.7704C25.83 44.88 25.9761 45.0627 26.1222 45.3183C26.2683 45.5375 26.3048 45.8297 26.3048 46.1219C26.3048 46.5237 26.1953 46.8525 25.9761 47.1081C25.7569 47.3638 25.4282 47.5465 24.9899 47.6195C25.1725 47.7291 25.2821 47.8022 25.3551 47.8752C25.5378 48.0578 25.6839 48.3135 25.8665 48.6057L26.6701 50.1033H25.8665L25.2456 48.971C25.0629 48.6423 24.9168 48.3866 24.8072 48.204C24.6977 48.0213 24.5881 47.9117 24.4785 47.8387C24.3689 47.7656 24.2959 47.7291 24.1863 47.6926C24.1132 47.6561 24.0037 47.656 23.8575 47.656H23.1635V50.1033H22.5426L22.5791 50.0668ZM23.2001 47.0351H24.515C24.8072 47.0351 25.0264 46.9986 25.1725 46.9255C25.3186 46.8525 25.4647 46.7429 25.5378 46.5968C25.6108 46.4507 25.6839 46.3046 25.6839 46.1219C25.6839 45.8662 25.5743 45.6471 25.4282 45.4644C25.2821 45.2818 24.9899 45.2088 24.6611 45.2088H23.2001V47.0351ZM29.8479 58.6141V53.1716H30.4689L32.9527 57.4452V53.1716H33.5371V58.6141H32.8797L30.4324 54.3404V58.6141H29.8479ZM24.9533 58.6141L26.7432 53.1716H27.4372L29.3366 58.6141H28.6425L28.0946 56.9704H26.1222L25.6108 58.6141H24.9533ZM26.3048 56.3859H27.912L27.4006 54.8884C27.2545 54.4135 27.145 54.0482 27.0719 53.756C26.9988 54.1213 26.9258 54.45 26.8162 54.8153L26.3048 56.4225V56.3859ZM20.7528 58.6141V53.1716H22.8348C23.2731 53.1716 23.5653 53.2081 23.7845 53.3177C24.0037 53.4273 24.1498 53.6099 24.2959 53.8656C24.442 54.1213 24.4785 54.377 24.4785 54.7057C24.4785 55.071 24.3689 55.3997 24.1498 55.6919C23.9306 55.9476 23.6019 56.1303 23.1635 56.2033C23.3462 56.3129 23.4557 56.3859 23.5288 56.459C23.7114 56.6416 23.8575 56.8973 24.0402 57.1895L24.8803 58.6871H24.0767L23.4557 57.5548C23.2731 57.2261 23.127 56.9704 23.0174 56.7877C22.8713 56.6051 22.7983 56.4955 22.6887 56.4225C22.5791 56.3494 22.5061 56.3129 22.3965 56.2764C22.3234 56.2398 22.2138 56.2398 22.0677 56.2398H21.3737V58.6871H20.7528V58.6141ZM21.3737 55.5824H22.6887C22.9809 55.5824 23.2001 55.5458 23.3462 55.4728C23.4923 55.3997 23.6384 55.2901 23.7114 55.144C23.7845 54.9979 23.821 54.8518 23.821 54.6692C23.821 54.4135 23.748 54.1943 23.6019 54.0117C23.4557 53.8656 23.1635 53.756 22.8348 53.756H21.3737V55.5824ZM19.036 58.6141V53.1716H19.657V58.6141H19.036ZM27.4006 50.1033V49.3363H28.0581V50.1033H27.4006ZM20.8258 50.1033V49.3363H21.4833V50.1033H20.8258Z"
              fill="#00FFF2"
            />
          </svg>
        </div>
      )}

      {/* /// pin img section start /// */}

      {mode !== "add" && (
        <>
          {carsLength > 1 && (
            <>
              <div
                className="absolute w-[3.471698113207547vw] h-[3.471698113207547vw] top-0 right-0 flex items-center justify-center p-[4.5vw] mr-[1vw]  "
                onClick={(e) => {
                  e.stopPropagation();
                  setTogglePin((prev) => !prev);
                  if (!togglePin) {
                    pinMe(plate);
                  } else {
                    unPinMe(plate);
                  }
                }}
              >
                <img
                  ref={pinImgRef}
                  src={`../assets/images/login/${
                    localStorage.getItem("P1") === plate
                      ? "pin-fill"
                      : localStorage.getItem("P2") === plate
                      ? "pin-fill"
                      : "pin"
                  }.svg`}
                  alt=""
                  className={`absolute w-[3.471698113207547vw] h-[3.471698113207547vw] ${
                    localStorage.getItem("P1") === plate
                      ? "C-pin"
                      : localStorage.getItem("P2") === plate
                      ? "C-pin"
                      : ""
                  }`}
                />
              </div>
              {!hasDefault && (
                <div
                  className="absolute w-[3.471698113207547vw] h-[3.471698113207547vw] top-0 right-[9vw] flex items-center justify-center p-[4.5vw] mr-[0.5vw]"
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsDefault1(true);
                    setHasDefault(true);
                    const config = {
                      headers: requestHeader,
                    };
                    axios
                      .post(
                        `${BASE_URL}/car/defaultCar`,
                        {
                          plate: plate,
                        },
                        config
                      )
                      .then((res) => {
                        var responseMode = res?.data?.Mode;
                        var responseMessage = res?.data?.Message;
                        switch (responseMode) {
                          case SERVERMODE.REQUEST_OK: {
                            contextData.setIsToastOpen(false);
                            contextData.setIsToastOpen(true);
                            contextData.setToastMessage(res?.data?.Message);
                            break;
                          }
                          default: {
                            handleServerMode(
                              responseMode,
                              responseMessage,
                              contextData,
                              cookies,
                              removeCookies,
                              navigate
                            );
                          }
                        }
                      })
                      .catch((err) => {
                        contextData.setIsToastOpen(true);
                        contextData.setToastMessage(
                          "ارتباط با سرور دچار مشکل شده است"
                        );
                      });
                  }}
                >
                  <img
                    src={`../assets/images/login/dif-unpin.svg`}
                    alt=""
                    className="absolute w-[5vw] h-[5vw]"
                  />
                </div>
              )}
            </>
          )}
          {hasDefault && isDefault1 && (
            <div
              className="absolute w-[3.471698113207547vw] h-[3.471698113207547vw] top-0 right-[9vw] flex items-center justify-center p-[4.5vw]   "
              onClick={(e) => {
                e.stopPropagation();
                setIsDefault1(false);
                setHasDefault(false);
                const config = {
                  headers: requestHeader,
                };
                axios
                  .post(
                    `${BASE_URL}/car/defaultCar`,
                    {
                      plate: plate,
                    },
                    config
                  )
                  .then((res) => {
                    var responseMode = res?.data?.Mode;
                    var responseMessage = res?.data?.Message;
                    switch (responseMode) {
                      case SERVERMODE.REQUEST_OK: {
                        contextData.setIsToastOpen(false);
                        contextData.setIsToastOpen(true);
                        contextData.setToastMessage(res?.data?.Message);
                        break;
                      }
                      default: {
                        handleServerMode(
                          responseMode,
                          responseMessage,
                          contextData,
                          cookies,
                          removeCookies,
                          navigate
                        );
                      }
                    }
                  })
                  .catch((err) => {
                    contextData.setIsToastOpen(true);
                    contextData.setToastMessage(
                      "ارتباط با سرور دچار مشکل شده است"
                    );
                  });
              }}
            >
              <img
                src={`../assets/images/login/dif-pin.svg`}
                alt=""
                className="absolute w-[5vw] h-[5vw]"
              />
            </div>
          )}
        </>
      )}

      {/* /// pin img section end /// */}
      {/* <div className="absolute w-[54vw] h-[10.5vw] top-[4vw] left-[4vw]  border-[1px] border-color-primary-B bg-color-primary-B -z-10 "></div> */}

      <div>
        <MaskedInput
          mask={[/[۰ -۹]|[0-9]/, /[۰ -۹]|[0-9]/]}
          guide={false}
          ref={plk1}
          id={id}
          value={pInp1}
          type="tel"
          dir="ltr"
          disabled={mode === "add" ? false : true}
          className={`absolute plk1  w-[8.5vw]  h-[5.971698113207547vw]  top-[6.27122641509434vw] left-[10.50235849056604vw] ${
            mode === "add" ? "bg-[rgba(226,227,229,0.2)] " : "bg-transparent"
          } text-color-primary-ImportBoxText focus:text-color-primary-ImportBoxText  flex items-center justify-center text-center text-[7vw] focus:text-[7vw] font-font_primary_A1 focus:font-font_primary_A1 outline-none leading-[5.9vw]`}
          onChange={(e) => {
            setPInp1(p2e(e.target.value));
            if (e.target.value.length === 2) {
              setIsPlateModalOpen(true);
              plk1.current.inputElement.blur();
            }
          }}
          onFocus={() => {}}
        />
        <MaskedInput
          mask={[/[۰ -۹]|[0-9]/, /[۰ -۹]|[0-9]/, /[۰ -۹]|[0-9]/]}
          guide={false}
          ref={plk2}
          value={pInp2}
          type="tel"
          dir="ltr"
          disabled={mode === "add" ? false : true}
          className={`absolute plk2 w-[14.3vw] h-[5.971698113207547vw] top-[6.27122641509434vw] left-[29.32547169811321vw] ${
            mode === "add" ? "bg-[rgba(226,227,229,0.2)] " : "bg-transparent"
          }    text-color-primary-ImportBoxText focus:text-color-primary-ImportBoxText  flex items-center justify-center text-center text-[7vw] focus:text-[7vw] font-font_primary_A1 focus:font-font_primary_A1 outline-none leading-[5.9vw]`}
          onChange={(e) => {
            setPInp2(p2e(e.target.value));
            if (e.target.value.length === 3) {
              plk3.current.inputElement.focus();
            }
            // if (e.target.value === "") {
            //   setPlateModalLetter("");
            //   plk1.current.inputElement.focus();
            // }
          }}
          onClick={() => {
            if (pInp1.length < 2) {
              plk1.current.inputElement.focus();
            }
          }}
          onKeyUp={(e) => {
            if (e.key === "Backspace") {
              if (e.target.value === "") {
                setPlateModalLetter("");
                plk1.current.inputElement.focus();
              }
            }
          }}
        />
        <MaskedInput
          mask={[/[۰ -۹]|[0-9]/, /[۰ -۹]|[0-9]/]}
          guide={false}
          ref={plk3}
          value={pInp3}
          type="tel"
          dir="ltr"
          disabled={mode === "add" ? false : true}
          className={`absolute w-[8.5vw] h-[5.971698113207547vw] top-[6.27122641509434vw] left-[46.81839622641509vw] ${
            mode === "add" ? "bg-[rgba(226,227,229,0.2)] " : "bg-transparent"
          }  text-color-primary-ImportBoxText focus:text-color-primary-ImportBoxText  flex items-center justify-center text-center text-[7vw] focus:text-[7vw] font-font_primary_A1 focus:font-font_primary_A1 outline-none leading-[5.9vw]`}
          onChange={(e) => {
            setPInp3(p2e(e.target.value));
            if (
              setValidPlateNumber(
                pInp1,
                plateModalLetter,
                pInp2,
                e.target.value
              ).length === 9
            ) {
              plk3.current.inputElement.blur();
            }
          }}
          onClick={() => {
            if (pInp2.length < 3) {
              plk2.current.inputElement.focus();
            }
            if (pInp1.length < 2) {
              plk1.current.inputElement.focus();
            }
          }}
          onKeyUp={(e) => {
            if (e.key === "Backspace") {
              if (e.target.value === "") {
                plk2.current.inputElement.focus();
              }
            }
          }}
        />
        <div
          className={`absolute w-[6.344339622641509vw] h-[5.971698113207547vw] top-[6.27122641509434vw] left-[21.25471698113208vw] ${
            mode === "add" ? "bg-[rgba(226,227,229,0.2)] " : "bg-transparent"
          } flex items-center justify-center text-color-primary-ImportBoxText text-center text-[5vw] font-font_primary_A outline-none leading-[5.9vw]`}
          onClick={() => {
            if (mode === "add") {
              if (pInp1.length < 2) {
                plk1.current.inputElement.focus();
              }
              if (pInp1.length === 2) {
                setIsPlateModalOpen(true);
              }
            }
          }}
        >
          {mode === "add" ? (
            <span>
              {pInp1 ? (
                plateModalLetter === "&" ? (
                  <FaWheelchair size={16.5} />
                ) : (
                  plateModalLetter
                )
              ) : (
                ""
              )}
            </span>
          ) : (
            <span>
              {getValidPlateNumber(plate, "S") === "&" ? (
                <FaWheelchair size={16.5} />
              ) : (
                getValidPlateNumber(plate, "S")
              )}
            </span>
          )}
        </div>
      </div>

      {/* //// logo section start /// */}
      {mode === "add" ? (
        <div
          className="absolute w-[15vw] h-[15vw] top-[8.5vw] right-[4.530660377358491vw]  "
          onClick={() => {
            if (
              setValidPlateNumber(pInp1, plateModalLetter, pInp2, pInp3)
                .length === 9
            ) {
              checkCarExist(
                setValidPlateNumber(pInp1, plateModalLetter, pInp2, pInp3)
              );
            } else {
              plk1.current.inputElement.focus();
            }
          }}
        >
          <svg
            className={`${
              setValidPlateNumber(pInp1, plateModalLetter, pInp2, pInp3)
                .length === 9
                ? "opacity-100"
                : "opacity-40"
            }`}
            width="15vw"
            height="15vw"
            viewBox="0 0 188 188"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_48_14)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.4583 0H162.542C176.25 0 188 11.75 188 25.4583V162.542C188 176.25 176.25 188 162.542 188H25.4583C11.75 188 0 176.25 0 162.542V25.4583C0 11.75 11.75 0 25.4583 0ZM148.833 80.2917C148.833 78.3333 146.875 76.375 146.875 76.375C144.917 74.4167 142.958 74.4167 141 74.4167C139.042 74.4167 137.083 74.4167 137.083 76.375C135.125 78.3333 135.125 80.2917 135.125 80.2917H127.292C127.292 78.3333 127.292 76.375 127.292 76.375C125.333 74.4167 123.375 74.4167 121.417 74.4167C119.458 74.4167 117.5 74.4167 117.5 76.375C115.542 78.3333 115.542 80.2917 115.542 80.2917H107.708C107.708 78.3333 107.708 76.375 105.75 76.375C103.792 74.4167 101.833 74.4167 101.833 74.4167C99.875 74.4167 97.9167 74.4167 97.9167 76.375C95.9583 76.375 94 80.2917 94 80.2917H88.125V47C88.125 43.0833 86.1667 43.0833 86.1667 41.125C84.2083 41.125 82.25 39.1667 82.25 39.1667C80.2917 39.1667 78.3333 41.125 76.375 41.125C76.375 43.0833 74.4167 45.0417 74.4167 47V101.833V103.792C72.4583 105.75 72.4583 105.75 70.5 105.75C70.5 107.708 68.5417 107.708 68.5417 107.708C66.5833 105.75 66.5833 105.75 64.625 105.75L50.9167 90.0833C48.9583 90.0833 47 88.125 47 88.125C45.0417 88.125 43.0833 90.0833 41.125 90.0833C39.1667 92.0417 39.1667 94 39.1667 94C39.1667 97.9167 41.125 99.875 41.125 99.875L72.4583 131.208L74.4167 133.167C74.4167 135.125 74.4167 137.083 74.4167 137.083V146.875V148.833C74.4167 148.833 74.4167 148.833 76.375 148.833C76.375 148.833 76.375 148.833 76.375 150.792C76.375 150.792 76.375 150.792 78.3333 150.792H131.208C135.125 150.792 139.042 148.833 142.958 144.917C146.875 141 148.833 137.083 148.833 133.167V80.2917ZM150.792 70.5C152.75 74.4167 154.708 76.375 154.708 80.2917V133.167C154.708 139.042 152.75 144.917 148.833 150.792C142.958 154.708 137.083 156.667 131.208 156.667H78.3333C76.375 156.667 74.4167 156.667 74.4167 156.667C72.4583 156.667 72.4583 154.708 70.5 154.708C70.5 152.75 68.5417 152.75 68.5417 150.792C68.5417 148.833 68.5417 148.833 68.5417 146.875V137.083C66.5833 135.125 66.5833 135.125 66.5833 135.125L37.2083 105.75C35.25 103.792 33.2917 99.875 33.2917 94C33.2917 92.0417 33.2917 88.125 37.2083 86.1667C39.1667 84.2083 43.0833 82.25 47 82.25C48.9583 82.25 52.875 82.25 54.8333 86.1667L68.5417 97.9167V47C68.5417 43.0833 68.5417 39.1667 72.4583 37.2083C74.4167 35.25 78.3333 33.2917 82.25 33.2917C84.2083 33.2917 86.1667 33.2917 90.0833 35.25C92.0417 39.1667 94 41.125 94 47V68.5417C95.9583 68.5417 99.875 66.5833 101.833 66.5833C103.792 66.5833 107.708 68.5417 111.625 70.5C111.625 72.4583 111.625 72.4583 111.625 72.4583C113.583 68.5417 117.5 66.5833 121.417 66.5833C123.375 66.5833 129.25 68.5417 131.208 70.5C131.208 72.4583 131.208 72.4583 131.208 72.4583C133.167 68.5417 137.083 66.5833 141 66.5833C144.917 66.5833 148.833 68.5417 150.792 70.5Z"
                fill={`${
                  setValidPlateNumber(pInp1, plateModalLetter, pInp2, pInp3)
                    .length === 9
                    ? "#00F7FF"
                    : "#EAEBEB"
                }`}
              />
            </g>
            <defs>
              <clipPath id="clip0_48_14">
                <rect width="188" height="188" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      ) : (
        <div className="absolute w-[15vw] h-[15vw] top-[8.5vw] right-[4.530660377358491vw]">
          <img src={`${logoSrcMain}`} alt="" />
        </div>
      )}
      {/* //// logo section end /// */}

      {/* /// percent section start /// */}
      <span
        className={`absolute top-[18.6438679245283vw] right-[39.82311320754717vw] font-font_primary_D text-[6.918238993710691vw] ${
          mode === "add"
            ? "text-color-primary-C"
            : `${
                percent <= 10 ? "text-color-primary-B" : "text-color-primary-D"
              }`
        }`}
      >
        {percent}%
      </span>
      {/* /// percent section end /// */}

      {/* /// progress bar section start /// */}
      <div
        dir="ltr"
        className={`absolute w-[83.16745283018868vw] h-[1.070754716981132vw] top-[27vw] right-[4.787735849056604vw] border-[1px] ${
          mode === "add"
            ? "border-color-primary-C"
            : `${
                percent <= 10
                  ? "border-color-primary-B"
                  : "border-color-primary-D"
              }`
        } bg-transparent overflow-hidden`}
      >
        <div
          className={`absolute top-0  h-full ${
            percent <= 10 ? "bg-color-primary-B" : "bg-color-primary-D"
          } `}
          style={{ width: `${percent}%` }}
        ></div>
      </div>
      {/* /// progress bar section end /// */}
    </div>
  );
}
